/*global window, jv:true, JV:true, angular:true, JV_FB:true,  FB:true, $:true, _gaq:true*/

//Base class constructor, angular service

	// Need to rename callback function name on both the publisher & contact details page. 

var JOBVITE = JOBVITE || {};
	JOBVITE.Publisher = {};

JOBVITE.Publisher.getUserData = function(params){
		window.location = window.location;
};


var JVNGsocialWidgets = angular.module('JVNG-socialWidgets', [ 'ngSanitize' ]);

JVNGsocialWidgets.factory('widgetClass', ['$http',function($http) {
			var widget = function(options) {
				this.platform = options.platform || "";
				this.id = options.id || "";
				this.query = options.query || "";
				this.url = options.url || "";
				this.page = options.page || 0;
			};

			widget.prototype.init = function() {
				var me = this;
				return {
					getProfiles : function(options, callback) {
						if( (options && !$.isEmptyObject(options))  ||  (me.platform === "2" && existsTwitterLink === "true") ){
							callback = callback || function() {};
							if (!options.isCustomQuery) {
								options = angular.extend({
									'page' : me.page,
									'query' : me.query,
									'id' : me.id,
									'url' : me.url
								}, options);
							}

							var url = JV.SOCIALPROFILE_URL + 'platform=' + me.platform;
							url += options.id ? '&socialId=' + options.id : "";
							url += options.query ? '&query=' + encodeURIComponent(options.query) : "";
							url += options.url ? '&url=' + encodeURIComponent(options.url) : " ";
							url += '&page=' + (options.page ? options.page : 0);

							$http.get(url).then(function(response) {
								callback(response.data);
							});
						}else{
							callback({});
						}
					},
					linkUnlink : function(options, callback) {
						options = $.extend({
							type : me.platform,
							customerId : JV.CONTACT_IDS
						// NOT THE COrrect way. Fix it.
						}, options);
						// We are not getting these parameters. kept these for
						// future use. Confirm with Ali
						var url = JV.BASE_URL + "action/person/contactDetailsPage?";
						url += (options.id) ? "q=" + options.id + "&" : "";
						url += (options.url) ? "url=" + encodeURIComponent(options.url) + "&" : "";
						url += (options.customerId) ? "ids=" + options.customerId + "&" : "";
						url += (options.attributeIds) ? "contactAttributeIds=" + options.attributeIds + "&" : "";
						url += 'action=doSaveURL&type=' + options.type;
						$http.get(url).then(function(response) {
							callback();
						});
					},
					getPlatformByName : function() {
						return "Twitter";
					},
					getTwitterHandle : function(profiles){
						if(angular.isArray(profiles)){
							angular.forEach(profiles, function(value , key){
								if(value.url.length > 0){
									value.twitterHandle = value.url.split('twitter.com/')[1];
									if(angular.isDefined(value.pictureUrl) && value.pictureUrl.indexOf("http:") == 0){
										value.pictureUrl = value.pictureUrl.slice(5);
									}
								}
							});
						}else{
							return  profiles.url.length > 0 ? profiles.url.split('twitter.com/')[1] : "";							
						}		
					}	
				};
			};

			return function(options) {
				return new widget(options);
			};
		} ]);


	JVNGsocialWidgets.controller('socialWidgetsCtrl', [function () {}]);

JVNGsocialWidgets.filter('formatDate', function() {
	function f(n){
		return n < 10 ? "0" + n : n; 
	}
	return function(date) {
		var myDate = new Date(date);
		return f(myDate.getMonth()+1) + "/" + f(myDate.getDate()) + "/" + myDate.getFullYear();
		
	};
});

// Directive to render the widget	
JVNGsocialWidgets.directive('jvCrmSocialWidget', function() {
					return {
						restrict : 'A',
						replace : true,
						templateUrl : JV.TEMPLATE_URL,
						transclude : true,
						scope : true,
						controller : function($scope, widgetClass, $element, $timeout, $window) {
							var _maxSearchResults= 8,
								getPlatformProperties = function(myScope) {
								switch (myScope.platform) {
								case "Twitter":
									myScope.platformPic = "/__assets__/images/icon-twitter.png";
									myScope.twitterFollow = true;
									if(myScope.show === "profile"){
										myScope.twitterHandle = myScope.init.getTwitterHandle(myScope.profile);
									}								
									myScope.heading = "Tweets"; // this is script from Twitter which needs to be executed for the follow button. It needs to run everytime the follow button renders.
									break;
								}

								if (myScope.noFeed) {
									myScope.heading = "This person has no " + myScope.heading;
								} else {
									myScope.heading = "Recent " + myScope.heading;
								}
							},
							
							getType = function(url){
								if(url.indexOf('www.linkedin.com/in') > -1){
									return "LinkedIn";
								}else if(url.indexOf('//twitter.com') > -1){
									return "Twitter";									
								}								
								return "Website";	
							};

							$scope.createWidgetClass = function(options) {
								$scope.widgetSubClass = widgetClass(options);
								$scope.init = $scope.widgetSubClass.init();
								$scope.platform = $scope.init.getPlatformByName();
								return $scope.widgetSubClass;
							};

							$scope.formatResults = function(myScope, response, firstLoad) {
								myScope.firstLoad = firstLoad;
								var myClass = myScope.widgetSubClass;
								myScope.noMore = true;
								$scope.newSearch = $scope.newSearch === undefined ? true : $scope.newSearch;
								
								if (response.socialResults) { // for profile search in the social.
									myScope.profileSearch= myClass.query;
									myScope.keyword= myClass.query;
									var temp = response.socialResults.slice(0,10);
									myScope.nextResultset = response.socialResults.slice(10);
									if ($scope.newSearch) {
										myScope.resultset = temp;
									} else {
										myScope.resultset = myScope.resultset
												.concat(temp);
									}

									if (myScope.nextResultset.length > 0) {
										myScope.noMore = false;
									}
									
									if(myScope.widgetSubClass.platform === "2"){
										myScope.handle = myScope.init.getTwitterHandle(myScope.resultset);										
									}
									myScope.show = "socialSearch";									
									getPlatformProperties(myScope);
								} else if (response.profile) {// if the backend finds the profile.
									myScope.platform = response.profile.platform;
									myScope.id = response.id;
									myScope.profile = response.profile;
									myScope.show = "profile";
									myScope.resultset = myScope.newSearch ? []
											: myScope.resultset;
									if (response.feed && response.feed.length > 0) {
										//myScope.resultset = myScope.resultset.concat(response.feed.slice(0, 10));
										myScope.resultset = response.feed.slice(0,10);
										myScope.noMore = false;
										myScope.noFeed = false;
									} else {
										myScope.noFeed = true;
									}
									getPlatformProperties(myScope);
								} else {
									if (response.error) {
										myScope.show = "error";
										switch (myClass.platform) {
										case "0":
											myScope.platform = "Facebook";
											break;
										case "2":
											myScope.platform = "Twitter";
											break;
										default:
											myScope.show = "noResults";
											break;
										}
									} else if ($.isEmptyObject(response) || (response.searchResults && response.searchResults.results && response.searchResults.results.length === 0)) {
										myScope.profileSearch = myScope.searchKeyword = myScope.widgetSubClass.query;
										myScope.searchKeyword = myScope.searchKeyword = myScope.widgetSubClass.query;
										myScope.show = "noResults";
									}
								}
							};

							$scope.loadMore = function(myScope) {
								myScope = myScope || $scope;
								var myClass = myScope.widgetSubClass;
								myScope.newSearch = false;
								if (myScope.nextResultset && myScope.nextResultset.length > 0) {
									myScope.resultset = myScope.resultset
											.concat(myScope.nextResultset);
									myScope.nextResultset = [];
								} else {
									myScope.init.getProfiles({
										page : ++myScope.widgetSubClass.page
									}, function(result) {
										myScope.formatResults(myScope, result);
									});
								}
							};

							$scope.linkUnlink = function(socialType, url, mode, model) {
								var myClass = $scope.widgetSubClass, 
									type = ($scope.platform === "Bing") ? getType(url) : $scope.platform;
								
								if (mode === 'unlink') {
									myClass.url = '';
									myClass.id = '';
									myClass.page = 0;
								} else {
									myClass.url = url;
								}

								$scope.init.linkUnlink({
									type : type,
									url : myClass.url
								}, function() {
									$scope.toggleMe(socialType, myClass.url, mode, model, type);
								});
							};
							
							$scope.connectTo = function(platform) {
								var authenticated = false;
								switch (platform) {
								case "Twitter":
									platform = 2;
									authenticated = true;
									window.open(JV.CONNECT_URL + platform,"null","height=400,width=835,status=yes,toolbar=no,menubar=no,location=no, status=no");
									break;
								}
							};

							$scope.instantSearch = function(socialType, keyword) {
								$scope.newSearch = true;
								if (keyword.length > 0) {
									$scope.widgetSubClass.query = keyword;
									$scope.init.getProfiles({
										query : keyword,
										isCustomQuery : true
									}, function(result) {
										$scope.formatResults($scope, result);
									});
								}
							};
						},
						
						link : function(scope, element, attrs, controller) {
							var myClass = scope.createWidgetClass({
								id : attrs.socialid || "",
								platform : attrs.platform || 2,
								query : attrs.query || "",
								url : attrs.url || ""
							});
							if (attrs.url) {
								scope.init.getProfiles({},function(result) {scope.formatResults(scope,result);});
							}
							scope.formatResults(scope, {}, true);
							scope.toggleMe = function(socialType, url, mode, model, type) {
								if (socialType === "web") {
									$("a." + model).closest('div.jv-webSearchResults').slideUp('500', function() {
										$(this).remove();
									});
									
									switch(type){
										case "Website" : 
											$('td.jv-fieldColumn.jv-contactDetailsWebsites').prepend('<div><a href="'+url+'" target="_blank">'+url+'</a></div>');
											break;
										case "LinkedIn" : 
											 $('td.jv-fieldColumn.jv-contactDetailsSocialNetworks > p:nth-child(1) > .jv-socialProfile').html('<a href="'+url+'" target="_blank">LinkedIn Profile</a>');
											break;
										case "Twitter" : 
											$('td.jv-fieldColumn.jv-contactDetailsSocialNetworks > p:nth-child(3) > .jv-socialProfile').html('<a href="'+url+'" target="_blank">Twitter Profile</a>');
											break;
										}
								} else {
									myClass.url = url;
									$('script#twitter-wjs').remove();
									scope.init.getProfiles({"Key":"Value"},function(result) {scope.formatResults(scope,result);});   //Passing key value pair so that getProfile does not get empty object because in that case no back-end call is made.
								}
							};
						}
					};
				});


JVNGsocialWidgets.directive('twtrFollowButton', function() {
	return{
		restrict : "A",
		transclude : true,
		replace:true,
		scope:{
			url : '@url'			
		},
		template: '<a href="{{url}}" class="twitter-follow-button" data-show-count="true" ng-transclude></a>',
		link: function(){
			!(function(d, s, id) {var js, fjs = d.getElementsByTagName(s)[0];if (!d.getElementById(id)) {js = d.createElement(s);js.id = id;js.src = "//platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js, fjs);}}(document, "script","twitter-wjs"));						
		}
	};
});
